import { Component, EventEmitter, Input, OnInit, Output } from '@angular/core';
import { IBreadcrumb } from 'projects/access-control/src/app/Domain/Entities/breabcumd.interface';

@Component({
	selector: 'app-breadcrumb',
	templateUrl: './breadcrumb.component.html',
	styleUrls: ['./breadcrumb.component.scss'],
})
export class BreadcrumbComponent implements OnInit {
	@Input() home: IBreadcrumb = { text: '', id: [''] };
	@Input() nameElements: IBreadcrumb[] = [];
	@Output() positionBreadcumbd = new EventEmitter<IBreadcrumb>();
	constructor() {}

	ngOnInit(): void {}
	viewSelected(selected: IBreadcrumb) {
		this.positionBreadcumbd.emit(selected);
	}
}
